import { CLASS_NAME } from 'constants/class-names'
import {
    EventType,
    HtmlAttr,
    KeyType,
    SlidingDrawerEvent
} from 'constants/enums'
import { Nullable } from 'constants/types'
import { TabIndexUtils } from 'utils/tab-index'
import { CSSUtils } from 'utils/css'
import { ComponentBase } from 'utils/abstract-classes/component-base'

export enum SlidingDrawerAnimations {
    OPEN = 'drawerSlideUp',
    CLOSE = 'drawerSlideDown'
}

export class SlidingDrawerComponent extends ComponentBase {
    private drawerClose: Nullable<HTMLButtonElement>
    private consentBanner: Nullable<HTMLElement>

    constructor(private drawer: HTMLElement) {
        super()

        this.drawerClose = this.getElement<HTMLButtonElement>(
            `.${CLASS_NAME.slidingDrawer.close}`,
            drawer
        )
        this.consentBanner = this.getElement(
            `.${CLASS_NAME.slidingDrawer.consentBannerPairing}`
        )

        window.addEventListener(SlidingDrawerEvent.OPEN, () =>
            this.openDrawer()
        )
        window.addEventListener(SlidingDrawerEvent.CLOSE, () =>
            this.closeDrawer()
        )

        // watch for completion of animation that opens and closes the drawer
        // dispatch event for their completion
        document.addEventListener(
            EventType.ANIMATION_END,
            (ev: AnimationEvent) => this.animationEndEventsHandler(ev)
        )

        if (this.drawerClose) {
            this.drawerClose.addEventListener(EventType.CLICK, () => {
                this.closeDrawer()
            })

            // when dismiss-able is allowed a close button should exist
            // attach escape key exit then
            document.addEventListener(EventType.KEYDOWN, (e: KeyboardEvent) => {
                if (e.key === KeyType.ESC || e.key === KeyType.ESC_IE) {
                    this.closeDrawer()
                }
            })
        }
    }

    private openDrawer(): void {
        if (
            this.drawer &&
            this.consentBanner &&
            !this.consentBanner.hasAttribute(HtmlAttr.HIDDEN)
        ) {
            this.consentBanner.style.transform = `translateY(-${this.drawer.clientHeight}px)`
        }

        CSSUtils.removeClass(this.drawer, CLASS_NAME.slidingDrawer.slideDown)
        CSSUtils.addClass(this.drawer, CLASS_NAME.slidingDrawer.slideUp)
        TabIndexUtils.removeTabIndex(this.drawer)
    }

    private closeDrawer(): void {
        if (
            this.consentBanner &&
            !this.consentBanner.hasAttribute(HtmlAttr.HIDDEN)
        ) {
            this.consentBanner.style.transform = 'translateY(0)'
        }
        CSSUtils.removeClass(this.drawer, CLASS_NAME.slidingDrawer.slideUp)
        CSSUtils.addClass(this.drawer, CLASS_NAME.slidingDrawer.slideDown)
        TabIndexUtils.hideTabIndex(this.drawer)
    }

    private animationEndEventsHandler(ev: AnimationEvent): void {
        if (ev.animationName === SlidingDrawerAnimations.CLOSE) {
            window.dispatchEvent(new CustomEvent(SlidingDrawerEvent.CLOSED))
        }
        if (ev.animationName === SlidingDrawerAnimations.OPEN) {
            window.dispatchEvent(new CustomEvent(SlidingDrawerEvent.OPENED))
        }
    }
}
